import { render } from "./AdminPackOpening.vue?vue&type=template&id=328b90c2&scoped=true"
import script from "./AdminPackOpening.vue?vue&type=script&lang=js"
export * from "./AdminPackOpening.vue?vue&type=script&lang=js"

import "./AdminPackOpening.vue?vue&type=style&index=0&id=328b90c2&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-328b90c2"]])

export default __exports__